import DigitalDataService from "./digitalDataService";
import StorageService from "./storageService";

function storageKey() {
  const RECENT_SEARCHES = "__recent_searches__";
  const userConfigId = DigitalDataService.userConfigId();

  if (userConfigId) {
    const key = RECENT_SEARCHES + userConfigId;

    let anonSearches = StorageService.getItem(RECENT_SEARCHES);
    if (anonSearches !== null) {
      anonSearches = JSON.parse(anonSearches);
      StorageService.removeItem(RECENT_SEARCHES);

      const userSearches = StorageService.getItem(key);

      if (userSearches !== null && anonSearches !== null) {
        const userSearchesArray: string[] = JSON.parse(userSearches);

        for (let i = anonSearches.length - 1; i >= 0; i--) {
          userSearchesArray.unshift(anonSearches[i]);
        }

        StorageService.setItem(key, JSON.stringify(userSearches));
      }
    }

    return key;
  }

  return RECENT_SEARCHES;
}

const RecentSearchesService = {
  get: () => {
    const recents = StorageService.getItem(storageKey());
    if (recents) {
      return JSON.parse(recents);
    }

    return null;
  },
  set: (recents: string[]) => {
    StorageService.setItem(storageKey(), JSON.stringify(recents));
  },
  addRecent: (value: string) => {
    let recents = RecentSearchesService.get();

    if (recents != null) {
      const index = recents.indexOf(value);
      if (index >= 0) {
        recents.splice(index, 1);
      }
      recents.push(value);

      if (recents.length > 25) {
        recents.pop();
      }
    } else {
      recents = [value];
    }

    RecentSearchesService.set(recents);
  },
  removeRecent: (value: string) => {
    const recents = RecentSearchesService.get();

    if (recents != null) {
      const index = recents.indexOf(value);

      if (index >= 0) {
        recents.splice(index, 1);
      }

      RecentSearchesService.set(recents);
    }
  },
};

export default RecentSearchesService;
